import {
	type InfiniteData,
	type UndefinedInitialDataInfiniteOptions,
	useInfiniteQuery,
} from "@tanstack/react-query";
import {
	limit,
	makeOffsetInfiniteQueryOptions,
	useResetInfiniteData,
} from "web_myplann/Api/infiniteQueryUtils";
import { NotificationsKeys } from "web_myplann/Api/Notifications/notificatioKeys";
import {
	getNotificationsGroupedV2,
	type NotificationGroupEnum,
	type NotificationListResponseDTO,
	type NotificationTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";

type Key = ReturnType<typeof NotificationsKeys.infiniteGroupedListFiltered>;

export const getNotificationsGroupedInfiniteOptions = (
	filterOnlyunread?: boolean,
	filterExcludetypes?: NotificationTypeEnum[],
	filterGroups?: NotificationGroupEnum[],
	filterDaygroupactive?: boolean,
): UndefinedInitialDataInfiniteOptions<
	NotificationListResponseDTO,
	Error,
	InfiniteData<NotificationListResponseDTO, number>,
	Key,
	number
> => ({
	queryKey: NotificationsKeys.infiniteGroupedListFiltered(
		filterOnlyunread,
		filterExcludetypes,
	),
	queryFn: (ctx) =>
		processResponseQuery(() =>
			getNotificationsGroupedV2(
				filterOnlyunread,
				filterExcludetypes,
				filterGroups,
				filterDaygroupactive,
				limit,
				ctx.pageParam,
			),
		)(ctx),
	...makeOffsetInfiniteQueryOptions({
		getTotal: (meta) =>
			filterOnlyunread ? meta?.unreadCount : meta?.totalCount,
	}),
	placeholderData: (prev) => prev,
});

export const useNotificationsGroupedQuery = (
	filterOnlyunread?: boolean,
	filterExcludetypes?: NotificationTypeEnum[],
	filterGroups?: NotificationGroupEnum[],
	filterDaygroupactive?: boolean,
	options?: { enabled?: boolean },
) => {
	useResetInfiniteData(
		NotificationsKeys.infiniteGroupedListFiltered(
			filterOnlyunread,
			filterExcludetypes,
		),
	);

	return useInfiniteQuery({
		...getNotificationsGroupedInfiniteOptions(
			filterOnlyunread,
			filterExcludetypes,
			filterGroups,
			filterDaygroupactive,
		),
		enabled: options?.enabled,
	});
};
